import React ,{useRef ,useEffect ,useState}from 'react';
import SecurityService from '../security/security.service';
import moment from 'moment'

import DynamicInputList from '../software-dynamic-version-3/list-input-v-3';
import DialogInput from '../software-dynamic-version-2/popup-dialog-input-v-2';


// import ChequeStatusAdd  from './cheque-status'
import ChequeStatusService from './cheque-status.service';
import AuditTable from '../audit-table/audit-table';
import './cheque-status.scss'
import securityService from '../security/security.service';
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons';



const ChequeStatusInput = (props) => {
    // let handleCheckboxChange = (e,props)=>{
    //   console.log(e)
    //   ChequeStatusService.delete(props.UserID).then(async (res)=>{
    //     document.getElementById(`checkbox_${props.UserID}`).checked =false
    //     await  showDialog('ALERT' ,<span class="error-success">User Actived</span>)
    //       // await getListService()
    //       })
    // }
    
    let columns = [
      { field: "TenantContractFSPaymentDetailID", headerText: 'Payment Detail ID', width: '140px', textAlign: 'right', headerTextAlign: 'center', other: [{allowEditing:false}] },
      { field: "AccountTitle", headerText: 'Account Title', width: '180px', textAlign: 'left', headerTextAlign: 'center', other: [{allowEditing:false}] },
      { field: "TenantCellNo", headerText: 'Tenant Cell No', width: '160px', textAlign: 'left', headerTextAlign: 'center', other: [{allowEditing:false}] },
      { field: "TenantEmail", headerText: 'Tenant Email', width: '200px', textAlign: 'left', headerTextAlign: 'center', other: [{allowEditing:false}] },
      { field: "ModeOfPayment", headerText: 'Mode of Payment', width: '160px', textAlign: 'left', headerTextAlign: 'center', other: [{allowEditing:false}] },
      { field: "ChequeNo", headerText: 'Cheque No', width: '150px', textAlign: 'left', headerTextAlign: 'center', other: [{allowEditing:false}] },
      { field: "ChequeDate", headerText: 'Cheque Date', width: '150px', textAlign: 'center', headerTextAlign: 'center', other: [{allowEditing:false}] },
      { field: "ChequeAmount", headerText: 'Cheque Amount', width: '150px', textAlign: 'right', headerTextAlign: 'center', other: [{allowEditing:false}] },
      { field: "ChequeStatus", headerText: 'Is Cheque Cleared?', width: '70px', textAlign: 'center', headerTextAlign: 'center', other: [{
        // freeze:'Right',
      
        
        template: function (args,grid) {
          console.log(args)
          console.log(grid)
          return (
            <>
              {/* <input type="checkbox" checked={args.data.ChequeStatus}  */}
              {/* // onChange={(e) => handleCheckboxChange(e, args.data)}  */}
              {/* /> */}
      
              <CheckBoxComponent
              checked={args.ChequeStatus}
              id={`checkbox_ChequeStatus_${args.TenantContractFSPaymentDetailID}`}
              onChange={(e) => {
                console.log(e);
                let data = {
                  TenantContractFSID:args.TenantContractFSID,
                  ModeOfPaymentID:args.ModeOfPaymentID,
                  ChequeNo:args.ChequeNo,
                  ChequeDate:args.ChequeDate,
                  ChequeAmount:args.ChequeAmount,
                  IsChequeCleared:e.target.checked,
                  TenantContractFSPaymentDetailID:args.TenantContractFSPaymentDetailID
                }
                console.log(data);
                ChequeStatusService.editChequeStatus(data).then((response)=>{
                  console.log('checkbox updated' ,  response);
                })
                
              }}
              />
            </>
          );
        },
      }]
      },
    ];
    

        const listActionComplete = async (grid , args ,getListService ,selectedRow  ,setDataSourceState ,addUserLog,editUserLog)=>{
          console.log(args )
          console.log(getListService )
          console.log(selectedRow )
    
        if (args.requestType == 'save' || args.requestType == 'cancel' ) {
          getListService()

        }
        
        if(args.action == 'edit'){
          ChequeStatusService.getPaymentDetailForList().then((res)=>{
            getListService()
            // tableName,tableIDValue,selectedRows,values
            // editUserLog('ChequeStatus',args.data.UserID,'UserID',{
            //   UserName:args.data.UserName,
            //   UserFullName:args.data.UserFullName,
            // })
          })
        }

        
       }
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = false
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = true
    let  allowDataBound = true
    let  allowGridSum = false
    let  isDialog = props.IsDialog == true ? true : false

       
        // Defines the  string
        // @default ChequeStatus${typeMode} 
        let ListSecurity='Cheque Status'
        let AddSecurity='Cheque Status'
        let EditSecurity='Cheque Status'
        let DeleteSecurity='Cheque Status'
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      // let toolbarOptions ='All';
      let toolbarOptions =['PDFExport','ExcelExport','Search','ColumnChooser'].filter(Boolean);
          

        //   const dialogRef = useRef(null);
        //   const showDialog = (header,title,actions =['OK']) => {
        //     return new Promise((resolve) => {
        //     // Destroy existing dialog if any
        //     if (dialogRef.current) {
        //       dialogRef.current.destroy();
        //     }
        //     const okButtons = actions.map((action) => ({
        //       buttonModel: {
        //         content: action,
        //         cssClass: 'e-flat',
        //         isPrimary: action === 'OK',
        //       },
        //       click: (e) => {
        //         hideDialog();
        //         resolve(action);
        //       },
        //     }));
        //     // Create a new dialog instance
        //     dialogRef.current = new DialogInput({
        //       content: ()=>(<>{title}</>),
        //       header:header,
        //       width:'340px',
        //       showButtons: true,
        //       buttons:okButtons
        //     });
        //     // Show the dialog programmatically
        //     dialogRef.current.show();

        //   });

        //   };
        // const hideDialog = () =>{
        //   if (dialogRef.current) {
        //   }
        //   dialogRef.current.hide();
        //   dialogRef.current.destroy();
        //   dialogRef.current = null; // Clean up reference after destruction
        // }

      const toolbarClicking =  async (grid , args , selectedRow , getListService)=>{
        console.log(grid , args)
        console.log(selectedRow)
      //   if(props.Active ==  false  ){
      //      if(args.name == "rowSelected" || args.name == "rowDeselected"){
      //     if(args.target?.type ==  'checkbox'){
      //   setTimeout( async () => {
          
      //     await getListService()
      //   }, 1500);
      // }
      // }
    
      // }
      //   if(args?.item?.properties?.id == 'IsActive'){
      //     if(selectedRow == undefined){
      //   await showDialog('WARNING' ,<span class="error-tooltip">Please select a row first!</span>)
      // }else{
      //   let dialogResult  = await showDialog('Confirmation' ,<span class="error-success">Are you sure you want to delete?</span> , ['OK','CANCEL'])
      //   console.log(dialogResult)
      // if(dialogResult == 'OK'){
      //   ChequeStatusService.delete(selectedRow.UserID).then(async (res)=>{
      //   await  showDialog('ALERT' ,<span class="error-success">RECORD(S) DELETED SUCESSFULLY</span>)
      //     await getListService()
      //       AuditTable.auditDelete('ChequeStatus',selectedRow.UserID,{
      //         UserName:selectedRow.UserName,
      //         FullName:selectedRow.FullName,
      //       })
      //     })
      //   }
      //   }
      //   }
        
      }
      
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'ChequeStatus' ,
                    TableID:'ChequeStatusID',
                   // Optional if Delete is Soft // TableSecurity:'ChequeStatusDelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'ChequeStatus' ,TableID:'ChequeStatusID', Optional // TableSecurity:'ChequeStatusDelete'}]
    let listDelete = [];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
    //  let filterColumns = [{ field: 'ChequeStatus', value: props?.vale   == false ? 'No' : 'Yes' }];
     let filterColumns = [{field: 'ChequeStatus', value: 'False' }];
      

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Normal';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = [];


    return (
      
        <DynamicInputList
        Id='ChequeStatus'
        ListTitle='Cheque Status - List'
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        DataSource:  ()=> ChequeStatusService.getChequeStatusForList()
                        }]}
        DefaultSortedColumnName={'TenantContractFSID'}
        // GridDialog={[
        //     {
        //         DialogType:'Self',
        //         Dialog:<ChequeStatusAdd GridID={'ChequeStatus'} CompanyID={securityService.getCompanyIDLoggedInUserId()} />
        
        //     }
        // ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            AllowTemplate={allowTemplate}
            ToolbarOption={toolbarOptions}
            AllowGrouping={allowGrouping}
            AllowExcelExport={allowExcelExport}
            AllowPdfExport={allowPdfExport} 
            ShowColumnChooser={showColumnChooser}
            AllowPaging={allowPaging}
            AllowDataBound={allowDataBound}
            // ListSecurity={ListSecurity}
            // AddSecurity={AddSecurity}
            // EditSecurity={EditSecurity}
            // DeleteSecurity={DeleteSecurity}
            DefaultSortedColumnSort={DefaultSortedColumnSort}
            FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            GroupColumns={groupColumns} 
            // ListDelete={listDelete}
             DeleteType={deleteType} 
            GridEditSettingMode={gridEditSettingMode}
            GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            // GridSumColumns={gridSumColumns}
            // AllowGridSum={allowGridSum}
            IsDialog={isDialog}

            {...props}
            ></DynamicInputList>

            );
}



export default ChequeStatusInput;
